<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 200px;" class="mr-1">
								<v-text-field clearable dense label="学号" outlined v-model="query.studentNo">
								</v-text-field>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								    transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									 transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
									</v-date-picker>
								</v-menu>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
						
					</v-row>
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-2">
							<v-btn @click="showAddDialog" small color="info">新增兑换订单</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
					
				</template>
				<template v-slot:item.status="{item}">
					<v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
					</v-chip>
				</template>
				<template v-slot:item.action="{item}">
					<v-btn :disabled="item.status !== '1'" @click="sendOut(item)" color="info" x-small>领取出库</v-btn>
					<v-btn :disabled="item.status !== '1'" @click="cancelOrder(item)" color="error" class="ml-3" x-small>取消兑换</v-btn>
				</template>
			
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		
		<!-- 添加dialog -->
		<v-dialog title="新增兑换订单" v-model="add.dialog" max-width="500">
			<v-card>
				<v-card-title>
					<span>新增兑换订单</span>
					<v-spacer></v-spacer>
					<v-icon @click="add.dialog = false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
					
						<v-col cols="12">
							<v-select :items="selectGiftList" v-model="add.order.giftId" @change="addGiftChanged"
							item-text="goodsName" item-value="id" label="礼品" dense outlined></v-select>
						</v-col>
						<v-col cols="6">
														
							<v-autocomplete :items="selectStudentList" v-model="add.order.studentId"
							        item-text="studentName" item-value="id"
							        label="学员"  dense outlined></v-autocomplete>
							
						</v-col>
						
						<v-col cols="6">
							<v-text-field label="礼品积分价格" v-model="add.order.pointPrice" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="数量" type="number" v-model="add.order.quantity" @change="addQuantityChanged" dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="需要的总积分" type="number" v-model="add.order.totalPoint" disabled dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddOder" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		

	</v-card>
</template>

<script>

	import utils from "../../../config/utils"
	export default {
		name: "exchange-order-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '积分兑换中心',
						disabled: true
					},
					{
						text: '兑换订单列表',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '礼物',
							value: 'goodsName',
							sortable: false
						},
						{
							text: '积分价格',
							value: 'pointPrice',
							sortable: false
						},
						{
							text: '礼物数量',
							value: 'quantity',
							sortable: false
						},
						{
							text: '总积分',
							value: 'totalPoint',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '状态',
							align: 'center',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectShopList:[], //选择门店数据源
				selectStudentList:[], //选择门店数据源
				selectGiftList:[], //选择门店数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					studentNo:"",
				},
				add:{
					dialog: false,
					order:{
						shopId:"",
						studentId:"",
						giftId:"",
						quantity:"",
						pointPrice:"",
						totalPoint:"",
					}
				}
			}
		},
		created() {
			// 获取门店列表
			this.shopId = utils.getCurrentShopId();
			// 获取商品
			this.getGiftListForSelect();
			this.getStudentsForSelect();
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog(){
				this.add.dialog = true;
			},
			addGiftChanged(giftId) {
				let gift = null;
				this.selectGiftList.forEach((item,index)=>{
					if (item.id == giftId){
						gift = item;
					}
				});
				
				this.add.order.pointPrice = gift.pointPrice;
				
			},
			addQuantityChanged(qty){
				if(this.add.order.pointPrice && qty){
					this.add.order.totalPoint = this.add.order.pointPrice * qty;
				}
				else{
					this.add.order.totalPoint = "";
				}
				
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/erp/exchange/order/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.shopId) {
					url += "&shopId=" + this.query.shopId;
				}
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			sendOut(item){
				//冻结
				const that = this;
				let url = `/erp/exchange/order/send/out/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("冻结成功");
							that.getTableDataList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			cancelOrder(item){
				//冻结
				const that = this;
				let url = `/erp/exchange/order/cancel/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("冻结成功");
							that.getTableDataList();
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "待领取";
				} else if (state === "2") {
					stName = "已领取";
				}
				else if (state === "0") {
					stName = "已取消";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "2") {
					color = "success";
				}else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAddOder(){
				//提交订单
				// api
				const that = this;
				let url = `/erp/exchange/order/create`;
				let postData = {...this.add.order};
				postData.shopId = this.shopId;
							
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
		
			getStudentsForSelect(){
				const that = this;
				let url = `/edu/shop/student/list/${this.shopId}`;
			
				this.axios.get(url).then(response => {
					
					console.log(response.data["data"]);
					if (response.data["code"] === 200) {
						that.selectStudentList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getGiftListForSelect(){
				const that = this;
				let url = `/erp/exchange/gift/list/${this.shopId}`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectGiftList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
</script>

<style>
</style>
